import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@chakra-ui/react';

export default function DeptGrid({ children, ...otherProps }) {
  return (
    <Grid
      templateColumns={{ base: 'repeat(6, 1fr)', lg: 'repeat(12, 1fr)' }}
      columnGap={{ base: '16px', md: '24px' }}
      rowGap={{ base: '16px', md: '24px' }}
      {...otherProps}
    >
      {children}
    </Grid>
  );
}

DeptGrid.propTypes = {
  children: PropTypes.node.isRequired,
};
